import { createSlice } from '@reduxjs/toolkit'

export const station = createSlice({
  name: 'reviews',
  initialState: {
    data: [],
    count: [],
    city: "",
    loading: false,
    site: "",
    metadata: {},
    washName: "",
    washCity: "",
    washMetadata: {},
    evName: "",
    evCity: "",
    evMetadata: {},
  },
  reducers: {
    setData: (state, item) => {
      state.data = item.payload
    },
    setCity: (state, item) => {
      state.city = item.payload
    },
    setLoading: (state, item) => {
      state.loading = item.payload
    },
    setCountStation: (state, item) => {
      state.count = item.payload
    },
    setSiteName: (state, item) => {
      state.site = item?.payload?.toLowerCase()
    },
    setMetadata: (state, item) => {
      state.metadata = item.payload
    },
    setWashMetadata: (state, item) => {
      state.washMetadata = item.payload
    },
    setWashName: (state, item) => {
      state.washName = item.payload
    },
    setWashCity: (state, item) => {
      state.washCity = item.payload
    },
    setEvMetadata: (state, item) => {
      state.evMetadata = item.payload
    },
    setEvName: (state, item) => {
      state.evName = item.payload
    },
    setEvCity: (state, item) => {
      state.evCity = item.payload
    }
  }
})

export const { setData, setCity, setLoading, setCountStation, setSiteName, setMetadata, setWashMetadata, setWashCity, setWashName,
  setEvCity, setEvMetadata, setEvName
} = station.actions
export default station.reducer